import {
  Avatar,
  Popover,
  Toggle,
  ToggleOption,
} from "@tag/tag-components-react-v4";
import { FC } from "react";
import { ApplicationUser } from "../../types/user";
import { dummyUsers } from "../../data/dummyUser";

type UserAvatarProps = {
  user: ApplicationUser;
  onUserChange: (userId: string) => void;
};

const UserAvatar: FC<UserAvatarProps> = ({ user, onUserChange }) => {
  const userToggles = (
    <ToggleOption key={user.userId} value={user.userId}>
      {user.organisationName}
    </ToggleOption>
  );

  return (
    <div>
      <Popover
        popoverFor={
          <Avatar
            src={process.env.REACT_APP_EVO_URL + "/images/user/small/" +user.userId}
            size="35px"
            onClick={() => console.log("Avatar clicked")}
            style={{ cursor: "pointer" }}
          />
        }
      >
        <Toggle value={user.userId} onChange={(e) => onUserChange(e.value!)}>
          {userToggles}
        </Toggle>
      </Popover>
    </div>
  );
};

export default UserAvatar;
